import {
  GET_INVOICES_REQUEST,
  GET_INVOICES_SUCCESS,
  GET_INVOICES_FAILURE,
  CREATE_INVOICE_REQUEST,
  CREATE_INVOICE_SUCCESS,
  CREATE_INVOICE_FAILURE,
  UPDATE_INVOICE_REQUEST,
  UPDATE_INVOICE_SUCCESS,
  UPDATE_INVOICE_FAILURE,
  GET_INVOICE_REQUEST,
  GET_INVOICE_SUCCESS,
  GET_INVOICE_FAILURE,
  GENERATE_PDF_REQUEST,
  GENERATE_PDF_SUCCESS,
  GENERATE_PDF_FAILURE,
  GET_SALES_SUMMARY_REQUEST,
  GET_SALES_SUMMARY_SUCCESS,
  GET_SALES_SUMMARY_FAILURE,
  CONVERT_ORDER_TO_INVOICE_REQUEST,
  CONVERT_ORDER_TO_INVOICE_SUCCESS,
  CONVERT_ORDER_TO_INVOICE_FAILURE,
  GET_INVOICE_PAYMENTS_REQUEST,
  GET_INVOICE_PAYMENTS_SUCCESS,
  GET_INVOICE_PAYMENTS_FAILURE,
  CANCEL_INVOICE_REQUEST,
  CANCEL_INVOICE_SUCCESS,
  CANCEL_INVOICE_FAILURE,
} from '../types';

const initialState = {
  invoices: [],
  currentInvoice: null,
  salesSummary: [],
  invoicePayments: {
    payments: [],
    paymentModeTotals: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      itemsPerPage: 10,
    }
  },
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
  loading: false,
  error: null,
};

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INVOICES_REQUEST:
    case CREATE_INVOICE_REQUEST:
    case UPDATE_INVOICE_REQUEST:
    case GET_INVOICE_REQUEST:
    case GENERATE_PDF_REQUEST:
    case GET_SALES_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_INVOICES_SUCCESS:
      return {
        ...state,
        invoices: action.payload.invoices,
        pagination: action.payload.pagination,
        loading: false,
        error: null,
      };

    case GET_INVOICE_SUCCESS:
      return {
        ...state,
        currentInvoice: action.payload,
        loading: false,
        error: null,
      };

    case CREATE_INVOICE_SUCCESS:
      return {
        ...state,
        invoices: [action.payload, ...state.invoices],
        currentInvoice: action.payload,
        loading: false,
        error: null,
      };

    case UPDATE_INVOICE_SUCCESS:
      return {
        ...state,
        invoices: state.invoices.map(invoice => 
          invoice.id === action.payload.id ? action.payload : invoice
        ),
        currentInvoice: action.payload,
        loading: false,
        error: null,
      };

    case GET_SALES_SUMMARY_SUCCESS:
      return {
        ...state,
        salesSummary: action.payload,
        loading: false,
        error: null,
      };

    case GENERATE_PDF_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case GET_INVOICES_FAILURE:
    case CREATE_INVOICE_FAILURE:
    case UPDATE_INVOICE_FAILURE:
    case GET_INVOICE_FAILURE:
    case GENERATE_PDF_FAILURE:
    case GET_SALES_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CONVERT_ORDER_TO_INVOICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CONVERT_ORDER_TO_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        invoices: [action.payload, ...state.invoices],
      };

    case CONVERT_ORDER_TO_INVOICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_INVOICE_PAYMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_INVOICE_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        invoicePayments: {
          payments: action.payload.data.payments,
          paymentModeTotals: action.payload.data.paymentModeTotals,
          pagination: action.payload.pagination,
        },
      };

    case GET_INVOICE_PAYMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CANCEL_INVOICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CANCEL_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        invoices: state.invoices.map(invoice =>
          invoice.id === action.payload.id
            ? { ...invoice, status: 'cancelled' }
            : invoice
        ),
        currentInvoice: state.currentInvoice?.id === action.payload.id
          ? { ...state.currentInvoice, status: 'cancelled' }
          : state.currentInvoice,
      };

    case CANCEL_INVOICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default invoiceReducer;
